import { useNavigate } from "react-router-dom";
import { Icon } from "../components/Icon";
import { ROLE_LABELS } from "@velivo/shared";
import { useAuth } from "../auth/AuthContext";

/**
 * FR-AUTH-05 — a lightweight Brand picker, shown ONLY when a user has more than
 * one grant and no remembered choice.
 *
 * The AC is explicit that a user must never be shown a selection screen they
 * don't need, so routing renders this only when it genuinely has a decision to
 * ask for. There is deliberately no "select an Organization" step at all.
 */
export function BrandPickerPage() {
  const { user, setActiveBrand } = useAuth();
  const navigate = useNavigate();

  return (
    <main
      style={{
        minHeight: "100%",
        display: "grid",
        placeItems: "center",
        padding: "var(--space-6)",
      }}
    >
      <div style={{ width: "100%", maxWidth: 560 }}>
        <header className="page__header" style={{ textAlign: "center" }}>
          <h1 className="page__title">Choose a brand</h1>
          <p className="page__subtitle">
            You have access to {user?.brandGrants.length} brands. We'll remember
            the one you pick.
          </p>
        </header>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "var(--space-2)",
          }}
        >
          {user?.brandGrants.map((grant) => (
            <button
              type="button"
              key={grant.brandId}
              className="card card--interactive"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "var(--space-4)",
                textAlign: "left",
                font: "inherit",
                padding: "var(--space-4) var(--space-6)",
              }}
              onClick={() => {
                setActiveBrand(grant.brandId);
                navigate("/", { replace: true });
              }}
            >
              <span>
                <span style={{ fontWeight: 600, display: "block" }}>
                  {grant.brandName}
                </span>
                <span
                  style={{
                    color: "var(--color-text-secondary)",
                    fontSize: "var(--font-caption-size)",
                  }}
                >
                  {ROLE_LABELS[grant.role]}
                  {grant.inherited && " · via your Organization role"}
                </span>
              </span>
              <span
                style={{ color: "var(--color-text-tertiary)", display: "flex" }}
              >
                <Icon name="arrowRight" />
              </span>
            </button>
          ))}
        </div>
      </div>
    </main>
  );
}
